import { useTranslation } from "react-i18next";

const KNOB_TRAVEL_PX = 96;
const SMOOTH_EASE = "cubic-bezier(0.22, 1, 0.36, 1)";

export default function LanguageSwitch({ onLanguageChange }) {
  const { t, i18n } = useTranslation("navbar");

  const currentLang = i18n.resolvedLanguage || i18n.language || "pt";
  const isEnglish = currentLang.startsWith("en");

  const toggleLanguage = () => {
    const nextLang = isEnglish ? "pt" : "en";
    onLanguageChange?.(nextLang);
  };

  const label = isEnglish
    ? t("language_english")
    : t("language_portuguese");
  const shortLabel = isEnglish ? "EN" : "PT";

  return (
    <>
      {/* Compact toggle for mobile / tablet */}
      <button
        type="button"
        onClick={toggleLanguage}
        className="lg:hidden inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-brand-200 bg-white text-[11px] font-bold text-brand-700 transition-colors hover:bg-gray-50/80 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-1 active:bg-gray-50"
        title={isEnglish ? "Switch to Portuguese" : "Switch to English"}
        aria-label={`Language: ${label}. Click to switch.`}
      >
        {shortLabel}
      </button>

      {/* Full pill toggle for desktop */}
      <button
        type="button"
        onClick={toggleLanguage}
        className="group relative hidden lg:inline-flex h-11 w-[8.75rem] shrink-0 items-center rounded-full border border-brand-200 bg-white p-1.5 transition-colors duration-500 ease-out hover:bg-gray-50/80 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 active:bg-gray-50"
        title={isEnglish ? "Switch to Portuguese" : "Switch to English"}
        aria-label={`Language: ${label}. Click to switch.`}
      >
        <div
          className="absolute top-1/2 left-1.5 h-8 w-8 rounded-full bg-brand-500 shadow-[0_1px_4px_rgba(0,0,0,0.18)] transition-[transform,box-shadow,background-color,filter] duration-500 group-active:brightness-90 group-active:shadow-[0_2px_10px_rgba(0,0,0,0.22)]"
          style={{
            transform: `translate(${isEnglish ? 0 : KNOB_TRAVEL_PX}px, -50%)`,
            transitionTimingFunction: SMOOTH_EASE,
          }}
          aria-hidden="true"
        />

        <span
          className={`pointer-events-none absolute left-11 text-sm font-medium text-brand-700 transition-all duration-500 ${
            isEnglish ? "translate-y-0 opacity-100" : "translate-y-0.5 opacity-0"
          }`}
          style={{ transitionTimingFunction: SMOOTH_EASE }}
          aria-hidden={!isEnglish}
        >
          {t("language_english")}
        </span>

        <span
          className={`pointer-events-none absolute left-3 text-sm font-medium text-brand-700 transition-all duration-500 ${
            isEnglish ? "translate-y-0.5 opacity-0" : "translate-y-0 opacity-100"
          }`}
          style={{ transitionTimingFunction: SMOOTH_EASE }}
          aria-hidden={isEnglish}
        >
          {t("language_portuguese")}
        </span>
      </button>
    </>
  );
}
